module.exports = __webpack_public_path__ + "static/Whistic-f05eb4b55f9d531c10e2c4252c8f4104.jpg";